
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/bank-transfers/webhook-events",
      function () {
        return require("private-next-pages/docs/bank-transfers/webhook-events.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/bank-transfers/webhook-events"])
      });
    }
  